// eslint-disable-next-line import/prefer-default-export
export const annotationPassword = 'Recuerda que tu contraseña debe contener: *Mínimo 8 caracteres y un número.';
